import axios from "axios";
const API_URLS = process.env.REACT_APP_API_URLS;

export const getDashboardData = async () => {
    try {
        const response = await axios.get(`${API_URLS}/summary/members`);
        return Promise.resolve(response.data);
    }catch (error) {
        return Promise.reject(error);
    }   
}

export const getDashboardSelfCare = async () => {
    try {
        const response = await axios.get(`${API_URLS}/summary/selfcare`);
        return Promise.resolve(response.data);
    }catch (error) {
        return Promise.reject(error);
    }   
}

export const getDashboardtransaction= async (value : any) => {
    const year = value ? value.substring(0,4) : new Date().getFullYear();
    const month = value ? value.substring(5,7) : new Date().getMonth() + 1;
    try {
        const response = await axios.get(`${API_URLS}/summary/transaction?year=${year}&month=${month}`);
        return Promise.resolve(response.data);
    }catch (error) {
        return Promise.reject(error);
    }   
}

export const getDashboardRedeemption= async (value : any) => {
    const year = value ? value.substring(0,4) : new Date().getFullYear();
    const month = value ? value.substring(5,7) : new Date().getMonth() + 1;
    try {
        const response = await axios.get(`${API_URLS}/summary/reward?year=${year}&month=${month}`);
        return Promise.resolve(response.data);
    }catch (error) {
        return Promise.reject(error);
    }   
}